import React from 'react';
import AnimatedNewsBlock from '../components/AnimatedNewsBlock';
import NewsSectionLink from '../components/NewsSectionLink';
import '../styles/Subsections.css';

import shakhtarLogo from '../img/shakhtarLogo.png';
import dynamoLogo from '../img/dynamoLogo.png';
import kryvbasLogo from '../img/kryvbasLogo.png';
import zoryaLogo from '../img/zoryaLogo.png';
import obolonLogo from '../img/obolonLogo.png';
import kolosLogo from '../img/kolosLogo.png';
import lnzLogo from '../img/lnzLogo.png';
import karpatyLogo from '../img/karpatyLogo.png';
import polissyaLogo from '../img/polissyaLogo.png';
import veresLogo from '../img/veresLogo.png';
import epitsenterLogo from '../img/epitsenterLogo.png';
import kudrivkaLogo from '../img/kudrivkaLogo.png';
import metalist1925Logo from '../img/metalist1925Logo.png';
import bukovynaLogo from '../img/bukovynaLogo.png'; 
import chornomoretsLogo from '../img/chornomoretsLogo.jpg';
import lberigLogo from '../img/lberigLogo.png';
import { FC_KHARKIV } from '../config/teamAliases';

export const uplClubs = [
  { name: 'Шахтар', image: shakhtarLogo, link: '/football-ukraine/shakhtar' },
  { name: 'ЛНЗ', image: lnzLogo, link: '/football-ukraine/lnz' },
  { name: 'Полісся', image: polissyaLogo, link: '/football-ukraine/polissya' },
  { name: 'Динамо Київ', image: dynamoLogo, link: '/football-ukraine/dynamo' },
  {
    id: FC_KHARKIV.id,
    name: FC_KHARKIV.name,
    section: FC_KHARKIV.name,
    aliases: FC_KHARKIV.aliases,
    image: metalist1925Logo,
    link: FC_KHARKIV.route,
  },
  { name: 'Колос', image: kolosLogo, link: '/football-ukraine/kolos' },
  { name: 'Кривбас', image: kryvbasLogo, link: '/football-ukraine/kryvbas' }, 
  { name: 'Зоря', image: zoryaLogo, link: '/football-ukraine/zorya' }, 
  { name: 'Карпати', image: karpatyLogo, link: '/football-ukraine/karpaty' },
  { name: 'Епіцентр', image: epitsenterLogo, link: '/football-ukraine/epitsenter' },
  { name: 'Верес', image: veresLogo, link: '/football-ukraine/veres' },
  { name: 'Оболонь', image: obolonLogo, link: '/football-ukraine/obolon' },
  { name: 'Кудрівка', image: kudrivkaLogo, link: '/football-ukraine/kudrivka' }, 
  { name: 'Буковина', image: bukovynaLogo, link: '/football-ukraine/bukovyna'},
  { name: 'Чорноморець', image: chornomoretsLogo, link: '/football-ukraine/chornomorets' },
  { name: 'Лівий Берег', image: lberigLogo, link: '/football-ukraine/lberig' },
];

const UplClubs = () => {
  return (
    <AnimatedNewsBlock currentPage="upl-clubs">
      <div className="subsections-container">
        {uplClubs.map((club) => (
          <NewsSectionLink
            to={club.link}
            section={club.section || club.name}
            key={club.name}
            className="subsection-item"
          >
            <img
              src={club.image}
              alt={club.name}
              className="club-logo-small"
            />
            <span className="subsection-title">{club.name}</span>
          </NewsSectionLink>
        ))}
      </div>
    </AnimatedNewsBlock>
  );
};

export default UplClubs;
